import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectMortgageMiniCalculatorSecondaryEnabled } from 'shared/selectors/featureToggle';
import { selectIsMortgageBrokerBannerAvailable } from 'shared/selectors/mortgageBroker';

import { OfferCardServicePlaceUnderMap } from './offer-card-service-place-under-map';
import { legacyCalculatorMarkupSelector } from './selectors';
import { trackLogoClick, trackSubmitButtonClick, trackDetailsButtonClick } from './tracking';
import { MortgageCalculator } from '../../../packages/mortgage-calculator';
import { CardSection } from '../../components/CardSection';
import { offerSelector, isOfferInGageSelector, banksListSelector, isNewbuildingSelector } from '../../selectors';
import { getDealType, isSale } from '../../utils/deal_type';
import { getOfferType, isResidential } from '../../utils/offer_type';
import { useMortgageRate } from '../mortgage/hooks/useMortgageRate';

export function MortgageCalculatorContainer() {
  const offer = useSelector(offerSelector);
  const isOfferInGage = useSelector(isOfferInGageSelector);
  const legacyCalculatorMarkup = useSelector(legacyCalculatorMarkupSelector);
  const banksList = useSelector(banksListSelector);
  const isMortgageBrokerBannerEnabled = useSelector(selectIsMortgageBrokerBannerAvailable);
  const isSecondaryMortgageCalculatorMFEnabled = useSelector(selectMortgageMiniCalculatorSecondaryEnabled);

  const price = offer.bargainTerms.prices.rur;
  const dealType = getDealType(offer);
  const offerType = getOfferType(offer);
  const rate = useMortgageRate();

  const isNewbuilding = useSelector(isNewbuildingSelector);

  if (
    isOfferInGage ||
    !isSale(dealType) ||
    !isResidential(offerType) ||
    isMortgageBrokerBannerEnabled ||
    isSecondaryMortgageCalculatorMFEnabled
  ) {
    return null;
  }

  return (
    <CardSection
      {...(!isNewbuilding && {
        id: 'servicePlaceUnderMap',
      })}
    >
      {legacyCalculatorMarkup ? (
        <OfferCardServicePlaceUnderMap markup={legacyCalculatorMarkup} />
      ) : (
        // Если верстки старого калькулятора нет - то либо нет предложений, либо калькулятора быть не должно
        // Такова реализация ручки старого калькулятора
        // Так как мы не знаем почему верстки нет - попробуем отрендерить новый калькулятор
        <MortgageCalculator
          initialPrice={price}
          initialRate={rate}
          initialPaymentPercent={20}
          initialYears={20}
          banksList={banksList}
          onLogoClick={trackLogoClick}
          onSubmitButtonClick={trackSubmitButtonClick}
          onDetailsButtonClick={trackDetailsButtonClick}
        />
      )}
    </CardSection>
  );
}
